'use strict';

const processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./components/search'));
});
